import { useEffect, useRef, useState } from 'react';

export default function VideoSection() {
  const videoRef = useRef<HTMLVideoElement>(null);
  const [isPlaying, setIsPlaying] = useState(false);
  const [isMuted, setIsMuted] = useState(false);

  useEffect(() => {
    if (videoRef.current) {
      videoRef.current.muted = isMuted;
    }
  }, [isMuted]);

  const togglePlay = () => {
    if (videoRef.current) {
      if (isPlaying) {
        videoRef.current.pause();
      } else {
        videoRef.current.play();
      }
      setIsPlaying(!isPlaying);
    }
  };

  const toggleMute = () => {
    setIsMuted(!isMuted);
  };

  return (
    <section id="tv" className="py-20 bg-gradient-to-br from-gray-900 via-black to-gray-900 relative overflow-hidden">
      <div className="absolute inset-0 bg-cover bg-center opacity-10"></div>
      
      <div className="container mx-auto px-4 relative z-10">
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
            📺 TV Flashback Ao Vivo 📺
          </h2>
          <div className="w-24 h-1 bg-gradient-to-r from-red-500 to-pink-500 mx-auto mb-6"></div>
          <p className="text-lg text-white/90 max-w-3xl mx-auto leading-relaxed">
            Assista agora a transmissão ao vivo da <strong>TV Flashback</strong> com os melhores clipes e músicas!
          </p>
        </div>

        <div className="max-w-5xl mx-auto">
          <div className="bg-gradient-to-br from-gray-800/50 to-gray-900/50 backdrop-blur-lg p-6 md:p-8 rounded-3xl border border-white/10 shadow-2xl">
            <div className="flex items-center justify-between mb-6">
              <div className="flex items-center space-x-3">
                <div className="w-3 h-3 bg-red-500 rounded-full animate-pulse"></div>
                <span className="text-white font-bold text-lg">TRANSMISSÃO AO VIVO</span>
              </div>
              <div className="flex items-center space-x-3">
                <button
                  onClick={toggleMute}
                  className="bg-white/10 hover:bg-white/20 text-white w-10 h-10 rounded-full flex items-center justify-center transition-colors cursor-pointer"
                  aria-label={isMuted ? 'Ativar som' : 'Desativar som'}
                >
                  <i className={`${isMuted ? 'ri-volume-mute-line' : 'ri-volume-up-line'} text-lg`}></i>
                </button>
                <button
                  onClick={togglePlay}
                  className="bg-gradient-to-r from-red-500 to-pink-500 hover:from-red-600 hover:to-pink-600 text-white px-6 py-3 rounded-full font-bold transition-all transform hover:scale-105 cursor-pointer whitespace-nowrap flex items-center"
                >
                  <i className={`${isPlaying ? 'ri-pause-line' : 'ri-play-line'} mr-2 text-lg`}></i>
                  {isPlaying ? 'Pausar' : 'Assistir'}
                </button>
              </div>
            </div>

            <div className="relative bg-black rounded-2xl overflow-hidden shadow-2xl" style={{ paddingBottom: '56.25%' }}>
              <video
                ref={videoRef}
                className="absolute top-0 left-0 w-full h-full object-contain"
                controls
                playsInline
                onPlay={() => setIsPlaying(true)}
                onPause={() => setIsPlaying(false)}
              >
                <source src="https://stmv7.voxtvhd.com.br/tvflashbacksoasmelhores/tvflashbacksoasmelhores.flv" type="video/x-flv" />
                <source src="https://stmv7.voxtvhd.com.br/tvflashbacksoasmelhores/tvflashbacksoasmelhores/playlist.m3u8" type="application/x-mpegURL" />
                Seu navegador não suporta a reprodução de vídeo.
              </video>
            </div>

            <div className="mt-6 grid grid-cols-1 md:grid-cols-3 gap-4">
              <div className="bg-white/5 backdrop-blur-sm p-4 rounded-xl border border-white/10 text-center">
                <i className="ri-music-2-line text-3xl text-pink-400 mb-2"></i>
                <h3 className="text-white font-bold text-sm mb-1">Clipes Musicais</h3>
                <p className="text-white/70 text-xs">Os melhores videoclipes</p>
              </div>
              <div className="bg-white/5 backdrop-blur-sm p-4 rounded-xl border border-white/10 text-center">
                <i className="ri-live-line text-3xl text-red-400 mb-2"></i>
                <h3 className="text-white font-bold text-sm mb-1">24h no Ar</h3>
                <p className="text-white/70 text-xs">Transmissão contínua</p>
              </div>
              <div className="bg-white/5 backdrop-blur-sm p-4 rounded-xl border border-white/10 text-center">
                <i className="ri-heart-line text-3xl text-purple-400 mb-2"></i>
                <h3 className="text-white font-bold text-sm mb-1">Flashback</h3>
                <p className="text-white/70 text-xs">Sucessos inesquecíveis</p>
              </div>
            </div>
          </div>
        </div>

        <div className="text-center mt-12">
          <div className="bg-gradient-to-r from-red-500/20 to-pink-500/20 backdrop-blur-sm p-6 rounded-2xl max-w-3xl mx-auto border border-white/10">
            <h3 className="text-2xl font-bold text-white mb-3">🎵 Curta e Compartilhe! 🎵</h3>
            <p className="text-white/90 text-base mb-4">
              Assista aos melhores clipes e compartilhe com seus amigos. A melhor programação musical está aqui!
            </p>
            <div className="flex flex-wrap justify-center gap-3">
              <a 
                href="https://chat.whatsapp.com/IYH2NXZCuKj42aNRqFXoGn?mode=wwt" 
                target="_blank" 
                rel="noopener noreferrer"
                className="bg-green-600 hover:bg-green-700 text-white px-5 py-2 rounded-full text-sm font-bold transition-colors cursor-pointer whitespace-nowrap flex items-center"
              >
                <i className="ri-whatsapp-line mr-2"></i>Compartilhar no WhatsApp
              </a>
              <a 
                href="https://t.me/+ewQZO8JR-64zNDgx" 
                target="_blank" 
                rel="noopener noreferrer"
                className="bg-blue-500 hover:bg-blue-600 text-white px-5 py-2 rounded-full text-sm font-bold transition-colors cursor-pointer whitespace-nowrap flex items-center"
              >
                <i className="ri-telegram-line mr-2"></i>Compartilhar no Telegram
              </a>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute top-20 left-10 w-40 h-40 bg-red-500/10 rounded-full blur-3xl animate-pulse"></div>
        <div className="absolute top-1/3 right-20 w-48 h-48 bg-pink-500/10 rounded-full blur-3xl animate-pulse delay-1000"></div>
        <div className="absolute bottom-20 left-1/4 w-44 h-44 bg-purple-500/10 rounded-full blur-3xl animate-pulse delay-500"></div>
      </div>
    </section>
  );
}
